import { useCallback } from 'react'
import { useSWRConfig } from 'swr'
import { SWRGlobalState } from 'swr/_internal'
import { composeSwrKey, serializeSwrKey } from '../stale-while-revalidate/cache-key'
import { useApiCache } from './useApiCache'
import { useApiRestClient } from '../providers/api-rest-client/api-rest-client'

export const useApiMutate = ({ method, key, args = {} }) => {
	const { mutate, cache: globalCache } = useSWRConfig()
	const client = useApiRestClient()

	const swrKey = composeSwrKey({ client, method, key, args })
	const swrKeySerialized = serializeSwrKey(swrKey)

	const cache = useApiCache({ method, key, args })

	return useCallback(
		(...mutateArgs) => {
			const mutateResult = mutate(swrKey, ...mutateArgs)

			const [EVENT_REVALIDATORS] = SWRGlobalState.get(globalCache)
			const revalidators = EVENT_REVALIDATORS[swrKeySerialized]

			if (!revalidators?.length) {
				cache.deleteData()
			}

			return mutateResult
		},
		// eslint-disable-next-line react-hooks/exhaustive-deps
		[mutate, cache, swrKeySerialized]
	)
}
